<template>

    <b-form id="spkbForm" validated novalidate>
      <template v-if="!loadingSubmit">
        <b-row v-if="counter > 0">
          <template v-for="(v, index) in spkb">
            <b-col sm="3" :key="uniqueId('a' + index)">
              <!-- <b-card size="sm"> -->
                <strong>{{ index }}</strong>
                <table
                  class="table table-bordered table-striped table-responsive"
                  style="width: 100%"
                >
                  <thead>
                    <tr>
                      <th class="th-400px">Nama Produk</th>
                      <th class="th-150px">Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(v2, index2) in v">
                      <tr :key="uniqueId('a' + index2)">
                        <td><div v-html="v2.product_name" /></td>
                        <td>{{v2.qty_bpp_final}}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              <!-- </b-card> -->
            </b-col>
          </template>
        </b-row>
        <b-row v-else>
          <b-col sm="12" class="text-center">No Data Available</b-col>
        </b-row>
      </template>

      <template v-else>
        <b-row>
          <b-col b-col sm="12">
            <loading></loading>
          </b-col>
        </b-row>
      </template>

      
    </b-form>
      
</template>

<script>
import { ModelSelect } from "vue-search-select";
import axios from "axios";
import interfaces from "@/templates/_interfaces.js";
import { required, between } from "vuelidate/lib/validators";
import loading from "@/templates/Loading.vue";
import _ from "lodash";
import * as moment from "moment";
import "moment/locale/id";
import { VueAutosuggest } from "vue-autosuggest";

const contains = function (min, max, value) {
  return value >= min || value <= max;
};

export default {
  name: "bpb-detail",
  components: {
    ModelSelect,
    loading,
    VueAutosuggest,
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true,
    },
    spkbNumber: {
      type: [Array, Object],
      default: () => []
    },
    // bppForm: {
    //   type: [Array, Object],
    //   default: () => []
    // }
  },
  data() {
    return {
      spkb: [],
      spkb_actual: [],
      bppForm: [],
      spkb_number: "",
      counter: 0,
      updated_flag: '1',
      loadingSubmit: false,
      filteredOptions: [],
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    uniqueId: function (param = "") {
      return _.uniqueId(param);
    },
    init: function (spkb_id) {
      //this.loading = true;
      this.spkb_number = spkb_id;
      //this.bppForm.spkb_number = spkb_id;
      this.getDetailSpkb(spkb_id);
    },
    formatPrice: function (value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
   checkVal: function(string, val) {
      if(isNaN(val)) {
        alert('Qty harus angka!');
        this.bppForm[string] = 0;
      }
    },
    getDetailSpkb: function (spkb_id) {
      this.loadingSubmit = true;
      this.axios
        //.get("mobile/dashboard/inventory/spkb-list-detail/" + spkb_id + "/")
        .post("web/spkb/spkb-bpb-detail-dashboard/", {spkb_number: spkb_id})
        .then((response) => {
          let data = response.data.data;
          this.spkb = data;
          this.updated_flag = response.data.updated_flag;
          this.counter = _.keys(this.spkb).length;
          console.log(this.spkb);
          // Object.entries(this.spkb).forEach((value, index) => {
          //   // let name = value[0].split(" - ");
          //   value[1].forEach((v, i) => {
          //     this.bppForm[v.order_id + "#" + v.product_id] = 0;
          //   });
          // });
          this.loadingSubmit = false;
           
        })
        .catch((error) => {
          this.expired(error, "Error Messages");
        })
        .finally(() => {
         
        });
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
    doSomething: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin memasukkan Qty BPB Final ?")) {
        let reGroup = {};
        reGroup.spkb_number = this.spkb_number;
        Object.assign(reGroup, this.bppForm);
        this.axios
          .post("web/spkb/spkb-bpb-final/", reGroup)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "SPKB Bpp",
                message: response.data.message,
              });
              this.loadingSubmit = false;
              this.$router.push({ path: "/spkb-bpb/all" });
            }
          })
          .catch((error) => {
            this.expired(error, "Error Messages");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    back: function () {
      this.$router.go(-1);
    },
    resetFrom: function () {},
  },
  mounted() {
    //this.counter = _.keys(this.spkb).length
    //let route = this.$route.path.split("/");
    this.init(this.spkbNumber);

  },
};
</script>


<style>

.demo {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

input {
  width: 260px;
  padding: 0.5rem;
}

.autosuggest__results > ul {
  width: 100%;
  color: rgba(30, 39, 46, 1);
  list-style: none;
  margin: 0;
  padding: 0.5rem 0 0.5rem 0;
}
.autosuggest__results > ul > li {
  margin: 0 0 0 0;
  border-radius: 5px;
  padding: 0.75rem 0 0.75rem 0.75rem;
  display: flex;
  align-items: center;
}
.autosuggest__results > ul > li:hover {
  cursor: pointer;
}

.autosuggest-container {
  display: flex;
  justify-content: center;
  width: 280px;
}

#autosuggest {
  width: 100%;
  display: block;
}
.autosuggest__results-item--highlighted {
  background-color: rgba(51, 217, 178, 0.2);
}
#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  font-family: monospace;
  font-size: 20px;
  border: 1px solid #616161;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  overflow: scroll;
  max-height: 200px;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results_item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results_title {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results_item:active,
.autosuggest__results .autosuggest__results_item:hover,
.autosuggest__results .autosuggest__results_item:focus,
.autosuggest__results
  .autosuggest__results_item.autosuggest__results_item-highlighted {
  background-color: #b6adad;
}

@media (min-width: 1200px){
  .modal-xl {
      max-width: 1500px;
  }
}
</style>